import { AxiosResponse } from 'axios';
import api from './Api'

interface IParmas {
    eventCouponId: string
    memberId: string
    tossPayId: string
}
export const createEventCouponHistory = (params: IParmas): Promise<AxiosResponse<any, any>> => {
    return api.post(`/eventCouponHistory`, params);
}